import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import React, { useEffect, useState } from 'react'
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import AutocompleteCreatable from '../../../shared_elements/components/AutocompleteCreatable';
import { AttachementsUpload } from '../../../shared_elements/components';
import { globalGetService, globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { addCustomAlertApi, updateCustomAlertApi } from '../apiService';
import { checkApiStatus } from '../../../utils';
import { enqueueSnackbar } from 'notistack';
import { regexConstants } from '../../../constants/regEx';
import moment from 'moment';
import { formatBytes } from '../../../utils/fileUpload';
import { useDispatch, useSelector } from 'react-redux';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { trackActivity } from '../../../utils/mixpanel';
import LessMoreTextFieldComp from '../../../shared_elements/components/LessMoreTextFieldComp';
import InfoIcon from '@mui/icons-material/Info'


function CustomAlertCRU({ modeType, addEditCustomAlert, onToggleModal, params, getResponseBack, onOpenAttachments, fileUpload }) {
    const dispatch = useDispatch();
    const { storageDetails, leaseBasicDetails } = useSelector((state) => state.leases);
    const [loading, setLoading] = useState(false);
    const [customAlertData, setCustomAlertData] = useState({ ...addEditCustomAlert?.data, sparta_users: addEditCustomAlert?.data?.sparta_users?.map(user => user.email), non_sparta_users: addEditCustomAlert?.data?.non_sparta_users?.map(user => user.email) });
    const [error, setError] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [cleared, setCleared] = useState(false);
    const [dropDownLoader, setDropDownLoader] = useState({ constant: false, user: false, currency: false });
    const [users, setUsers] = useState([]);

    const viewModeAutocompleteSx = modeType === "view" ? {
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#969696",
            opacity: 1
        },
        "& .MuiChip-root.Mui-disabled": {
            opacity: 1,
            backgroundColor: "#e2e2e2",
            "& .MuiChip-label": { color: "#969696", }
        },
    } : {};

    useEffect(() => {
        getUserList();
    }, [])
    const addEditCustomAlertDatas = () => {
        let validationInputs = {};
        validationInputs = {
            name: customAlertData?.name ? "" : "Please enter Name",
            frequency_to_notify: customAlertData?.frequency_to_notify ? "" : "Please enter Notify Days",
            end_date: customAlertData?.end_date ? "" : "Plese enter End Date"
        };
        const startDate = moment(customAlertData?.start_date);
        const endDate = moment(customAlertData?.end_date);
        const leaseStartDate = moment(leaseBasicDetails?.start_date);
        const leaseEndDate = moment(leaseBasicDetails?.end_date);
        const hasLeaseDateRange = leaseStartDate.isValid() && leaseEndDate.isValid();

        if ( hasLeaseDateRange && customAlertData?.start_date && startDate.isValid() && (startDate.isBefore(leaseStartDate, "day") || startDate.isAfter(leaseEndDate, "day")) ) {
            validationInputs.start_date = "Start date must be within the lease period";
        }

        if ( hasLeaseDateRange && customAlertData?.end_date && endDate.isValid() && (endDate.isBefore(leaseStartDate, "day") || endDate.isAfter(leaseEndDate, "day")) ) {
            validationInputs.end_date = "End date must be within the lease period";
        }

        if (customAlertData?.start_date && customAlertData?.end_date && !validationInputs.start_date && !validationInputs.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before start date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after end date";
            }
            if (customAlertData?.start_date && !startDate.isValid()) {
                validationInputs.start_date = "Please enter valid Start date";
            }
            if (customAlertData?.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid End Date";
            }
        }

        const hasSpartaUsers = customAlertData?.sparta_users?.length > 0;
        const hasNonSpartaUsers = customAlertData?.non_sparta_users?.length > 0;
        if (!hasSpartaUsers && !hasNonSpartaUsers) {
            setLoading(false);
            enqueueSnackbar("Please add Sparta users or Non-Sparta users", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            return;
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, customAlertData);
            payload = {
                ...payload,
            }
            if (customAlertData.id) {
                globalPutService(updateCustomAlertApi({ ...params, slug: customAlertData?.slug }), payload)
                    .then(async (response) => {
                        if (uploadedFiles?.length > 0) {
                            fileUpload(customAlertData.slug, 'updated');
                        }
                        if (checkApiStatus(response)) {
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            trackActivity('Item Edited', { page_title: `Edit Custom Alert`, success_msg: response?.data?.message, item_id: customAlertData?.id, payload: customAlertData, response: response?.data })
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                            trackActivity('Item Edited', { page_title: `Edit Custom Alert`, error_msg: response?.data?.message, item_id: customAlertData?.id, payload: customAlertData, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addCustomAlertApi({ leaseSlug: params?.leaseSlug }), payload)
                    .then(async (response) => {
                        if (uploadedFiles?.length > 0) {
                            fileUpload(response?.data?.data.slug, 'created');
                        }
                        if (checkApiStatus(response)) {
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            trackActivity('Item Added', { page_title: `Add Custom Alert`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: customAlertData, response: response?.data })
                            enqueueSnackbar(response?.data?.message, {
                                variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }
                            })
                        } else {
                            setLoading(false);
                            trackActivity('Item Added', { page_title: `Add Custom Alert`, error_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: customAlertData, response: response?.data })
                            enqueueSnackbar(response?.data?.message, {
                                variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }
                            })
                        }
                    })
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Custom Alert`, error_msg: validationInputs, })
        }
    }
    const getUserList = () => {
        setDropDownLoader(prev => ({ ...prev, user: true }));
        globalGetService('/console/custom_alert/user_dropdown/')
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, user: false }));
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUsers(response?.data?.data);
                }
            })
    }

    const getValidEmails = (value = []) => {
        if (!Array.isArray(value)) return [];
        return [
            ...new Set(
                value
                    .map(item => item?.label ?? item)
                    .filter(email => regexConstants.email.test(email))
            )
        ];
    };
    const handelInputChange = (key, value) => {
        setCustomAlertData({ ...customAlertData, [key]: value })
    }

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const handleFileChange = (files) => {
        setUploadedFiles(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Custom Alert`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={addEditCustomAlert?.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className='dialog-header-title'>
                        {modeType === 'add' ? "Add Custom Alert" : modeType === 'edit' ? 'Edit Custom Alert' : 'View Custom Alert'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id='name'
                                label="Name"
                                value={customAlertData?.name}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("name", e.target.value.trimStart()) : e.preventDefault();
                                    setError(prev => ({ ...prev, name: "" }));
                                }}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                required
                                disabled={modeType === "view"}
                                helperText={error.name}
                                error={error.name}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id='frequency_to_notify'
                                label={
                                    <span>
                                        Notify Days
                                        <Tooltip placement='right' title={<span>Specifies the advance notice period (in days) for triggering an automated email alert before the scheduled due date</span>} arrow>
                                            <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                                        </Tooltip>
                                    </span>
                                }
                                value={customAlertData?.frequency_to_notify || ""}
                                // onChange={(e) => { regexConstants.numWithComa.test(e.target.value.trimStart()) || e.target.value === "" ? handelInputChange("frequency_to_notify", e.target.value.trimStart()) : e.preventDefault(); setError(prev => ({ ...prev, frequency_to_notify: "" })) }}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\s+/g, "");
                                    if (/^[0-9,]*$/.test(value)) {
                                        handelInputChange("frequency_to_notify", value);
                                        setError(prev => ({ ...prev, frequency_to_notify: "" }));
                                    }
                                }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                required
                                disabled={modeType === "view"}
                                error={Boolean(error?.frequency_to_notify)}
                                helperText={error?.frequency_to_notify || ""}
                                placeholder='Ex: 90,60,30'
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Start Date"
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true }, size: "small", margin: "normal",
                                            error: error.start_date || false,
                                            helperText: error.start_date || '',
                                            onFocus: () => { error.start_date && onRestErrorKey("start_date"); },
                                        },
                                        field: { clearable: true, onClear: () => { handelInputChange("start_date", null); } },
                                    }}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view'}
                                    format={fieldDateFormat}
                                    value={customAlertData?.start_date ? moment(customAlertData?.start_date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        handelInputChange("start_date", value ? moment(value).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("start_date");
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="End Date"
                                    minDate={customAlertData?.start_date ? moment(customAlertData.start_date) : null}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true }, size: "small", margin: "normal",
                                            error: error.end_date || false,
                                            helperText: error.end_date || '',
                                            onFocus: () => { error.end_date && onRestErrorKey("end_date"); },
                                        },
                                        field: { clearable: true, onClear: () => { handelInputChange("end_date", null); } },
                                    }}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === 'view'}
                                    format={fieldDateFormat}
                                    value={customAlertData?.end_date ? moment(customAlertData?.end_date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        handelInputChange("end_date", value ? moment(value).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("end_date");
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disableClearable
                                disabled={modeType === "view"}
                                options={[
                                    { label: "Active", value: true },
                                    { label: "Inactive", value: false }
                                ]}
                                getOptionLabel={(option) => option?.label || ""}
                                size="small"
                                value={{
                                    label: (customAlertData?.status ?? true) ? "Active" : "Inactive",
                                    value: customAlertData?.status ?? true
                                }}
                                onChange={(e, value) =>
                                    handelInputChange("status", value?.value)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        size="small"
                                        margin="normal"
                                        required
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Autocomplete
                                multiple
                                disablePortal
                                disableClearable
                                options={users ? users.map((user) => user?.email).filter(Boolean) : []}
                                value={customAlertData?.sparta_users || []}
                                filterSelectedOptions
                                onChange={(e, newValue) => {
                                    handelInputChange("sparta_users", newValue);
                                    const nonSpartaLength = customAlertData?.non_sparta_users?.length || 0;
                                    if (newValue?.length === 0 && nonSpartaLength === 0) {
                                        onRestErrorKey("sparta_users");
                                    }
                                }}
                                disabled={modeType === "view"}
                                noOptionsText={dropDownLoader?.user ? "Loading..." : "No Option Available"}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="SPARTA User"
                                        size="small"
                                        placeholder={(customAlertData?.sparta_users?.length ?? 0) > 0 ? "" : "Select User(s)"}
                                        sx={viewModeAutocompleteSx}
                                        slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: ( <> {modeType !== "view" && dropDownLoader?.user && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </> ), }, }}
                                        disabled={modeType === "view"}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }} sx={viewModeAutocompleteSx}>
                            <AutocompleteCreatable
                                label="Non-SPARTA User"
                                multiple
                                disableClearable
                                isDisabled={modeType === "view"}
                                options={[]}
                                value={customAlertData?.non_sparta_users || []}
                                onFieldChange={(e, key, newValue) => {
                                    const validEmails = getValidEmails(newValue);
                                    handelInputChange('non_sparta_users', validEmails);
                                    const spartaLength = customAlertData?.sparta_users?.length || 0;
                                    if (newValue.length === 0 && spartaLength === 0) {
                                        onRestErrorKey("sparta_users");
                                    }
                                }}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Description' value={customAlertData?.description} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id='description'
                                    label="Description"
                                    value={customAlertData?.description}
                                    onChange={(e) => { handelInputChange("description", e.target.value) }}
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    rows={3}
                                    multiline
                                    disabled={modeType === "view"}
                                />
                            </Grid>}
                        <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {customAlertData?.id && customAlertData?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({customAlertData?.attachments?.length})Attachment(s)</Button> : <Button color='primary' variant='outlined' size='small' sx={{ marginBottom: '10px' }}>Attachments</Button>
                                }
                                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {
                                modeType === "view" ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={customAlertData?.attachments} remainingStorage={storageDetails?.remaining_storage} />
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked(modeType === "view" ? "Close" : "Cancel") }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant='contained' size='small' className='btn-primary' onClick={() => { addEditCustomAlertDatas(); handleItemClicked('Save Button') }}>
                            {loading ? <CircularProgress color='inherit' size={24} /> : "Save"}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CustomAlertCRU
